import {combineReducers, configureStore} from '@reduxjs/toolkit'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import game from './game/slice'
import letters from './letter/slice'
import secretWord from './secretword/slice'
import translates from './translates/slice'
import modal from './modal/slice'
import topcup from './topcup/slice'

const rootReducer = combineReducers({
  game,
  letters,
  secretWord,
  translates,
  modal,
  topcup,
});

const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
